import { TS_OfferHotel } from "../TravelSeller/Models/TS_OfferHotel";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferHotel extends TS_OfferHotel implements BookingItemInterface {}
